import { atom } from "recoil";

export const apiDataFetchingLandingAtom = atom<boolean>({
  key: "apiDataFetchingLandingAtom",
  default: false,
});
